import CardSystem from '../CardSystem';
import { ICardsState } from '../../../State/Card/ICardState';
import BaseCardHandler from './BaseCardHandler';

export default class PlinkoCardHandler extends BaseCardHandler {
    // Empty override to prevent the card from being hidden on discard
    public handleCardDiscarded(state: ICardsState, cardSystem: CardSystem): void {}
}
